// SubscriptionText.js
import { loadStripe } from '@stripe/stripe-js';
import { CardElement, Elements, useStripe, useElements } from '@stripe/react-stripe-js';
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { Button } from './Button';


const SubscriptionText = ( data) => {
  const [userDetails, setUserDetails] = useState({ name: '', email: ''})

  useEffect(() => {
 	  const queryString = window.location.search;
	  const urlParams = new URLSearchParams(queryString);
	  const email = urlParams.get('inf_field_Email');
	  const name = urlParams.get('inf_field_FirstName');

	  setUserDetails({name,email});
  }, [])


  const [showModal, setShowModal] = useState(false);
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    const fetchStripePublicKey = async () => {
      try {
        const functionURL = 'https://us-central1-development-super-conference.cloudfunctions.net/getStripeKey-1';
  
        const response = await fetch(functionURL, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
    
        if (response.ok) {
          const data = await response.json();
          // Load Stripe with the dynamically fetched public key
          setStripePromise(loadStripe(data.publicKey));
        } else {
          console.error('Failed to fetch data:', response.status, response.statusText);
        }
      } catch (error) {
        console.error(error.message);
      }
    };
  
    fetchStripePublicKey();
  }, []);
   

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div>
      <span
        onClick={openModal}
        style={{ cursor: 'pointer', color: '#1e1a1a', fontSize: '1.1rem', fontWeight: 'bold' }}
      >{data.price}
      </span>
      
      <Modal
        isOpen={showModal}
        onRequestClose={closeModal}
        contentLabel="Subscription Modal"
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          },
          content: {
            width: '50%', // Set the desired width
            height: '50%', // Set the desired height
            margin: 'auto', // Center the modal
          },
        }}
      >
        <Elements stripe={stripePromise}>
          <CheckoutForm email={userDetails.email} name={userDetails.name} product_id={data.product_id} payment_type={data.paymentType} closeModal={closeModal} />
        </Elements>
      </Modal>
    </div>
  );
};

const CheckoutForm = ({ email, name, product_id, payment_type, closeModal }) => {
  const stripe = useStripe();
  const elements = useElements();


  const stripeProcess = async (email, name, token, product_id) => {
    try {
      const functionURL = 'https://us-central1-development-super-conference.cloudfunctions.net/stripe';
  
      const response = await fetch(functionURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email, name: name, token: token.id, product_id: product_id, payment_type: payment_type }),
      });
  
      const data = await response.json();
      // console.log(data);
    } catch (error) {
      console.error(error.message);
      throw error;
    }
  };
  

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    const cardElement = elements.getElement(CardElement);

    try {
      const { token, error } = await stripe.createToken(cardElement);

      if (error) {
        console.error(error.message);
      } else {
        const existingCustomerId = await stripeProcess(email, name, token, product_id);
        // console.log(existingCustomerId);

        closeModal(); // Close the modal after successful submission
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <label htmlFor="cardNumber">Card Details:</label>
       <CardElement options={{ style: { base: { fontSize: '16px' } } }} /> 
      

      <Button type="submit" disabled={!stripe}>
        Pay
      </Button>
    </form>
  );
};

export default SubscriptionText;
